export enum SLAStatus {
  ON_TIME = 'ON_TIME',
  WARNING = 'WARNING',
  EXPIRED = 'EXPIRED'
}
